import { fromJS } from 'immutable'
import {
  SALE_PRODUCT_LIST_REQUEST,
  SALE_PRODUCT_LIST_SUCCESS,
  SALE_PRODUCT_LIST_FAILURE,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SALE_PRODUCT_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case SALE_PRODUCT_LIST_SUCCESS:
      return state
        .set('products', fromJS(action.payload.products))
        .set('isFetching', false)
    case SALE_PRODUCT_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-list-reducer.js